import { render, staticRenderFns } from "./hotPanelText.vue?vue&type=template&id=205cd633&scoped=true"
import script from "./hotPanelText.vue?vue&type=script&lang=js"
export * from "./hotPanelText.vue?vue&type=script&lang=js"
import style0 from "./hotPanelText.vue?vue&type=style&index=0&id=205cd633&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205cd633",
  null
  
)

export default component.exports